import React from 'react'
import Caixa from '../ModulosCrefito/Caixa'
import HeaderVerde from '../ModulosCrefito/HeaderVerde'
import Select from '../ModulosCrefito/Select'
import Observacoes from '../ModulosCrefito/Observacoes'
import Input from '../ModulosCrefito/Input'
import Fiscalizadores from '../ModulosCrefito/Modulos/Fiscalizadores'

import { useSelector, useDispatch } from 'react-redux'

const Fechado = () => {
    const ficha = useSelector((state) => state.addForm.modulos)

    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <Caixa>
                <HeaderVerde texto="ESTABELECIMENTO FECHADO/DESATIVADO" />
                <div style={{ margin: "auto", width: "60vw", textAlign: "left" }}>
                    {ficha.fechado[0].situacao !== "Outro" ? (
                        <Select label="Situação" nome="situacao" modulo="fechado" index={0}
                            componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" marginR="4vw"
                            array={["Fechado", "Desativado", "Outro"]} />
                    ) : (RenderOutro())}
                    <Select label="Tipo" nome="tipo" modulo="fechado" index={0}
                        componentDisplay="inline-grid" widthDiv="28vw" widthMobile="80vw"
                        array={["Caps", "Clínica", "Consultório", "Hospital", "ILPI", "Nasf", "CER", "Outro"]} />
                    <Observacoes widthWeb="60vw" widthMobile="80vw" modulo="fechado" index={0} nome="observacoes" />
                </div>
            </Caixa>
        </>
    )

    function RenderOutro() {
        if (ficha.fechado[0].situacao === "Outro") {
            return (
                <Input label="Situação" nome="situacaooutro" modulo="fechado" index={0}
                    componentDisplay="inline-grid" widthWeb="28vw" widthMobile="80vw" marginR="3vw" />
            )
        }
    }
}

export default Fechado